import { useStrings } from "features/i18n/useStrings";
import strings from "./RemainingCharacters.strings";

export function RemainingCharacters({
    currentCount,
    totalCount,
}: {
    currentCount?: number;
    totalCount?: number;
}) {
    const t = useStrings(strings);
    return totalCount ? (
        <div className="RemainingCharacters" data-testid="remaining-characters">
            {t.charactersRemaining({
                remaining: totalCount - (currentCount ?? 0),
                total: totalCount,
            })}
        </div>
    ) : (
        <></>
    );
}
